/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import FullScreenButton from 'DesignSystem/FullScreenButton/index'
import ImageSeriesDate from './ImageSeriesDate/index'
import Info from 'DesignSystem/Info/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import PatientAge from './PatientAge/index'
import PatientImages from './PatientImages/index'
import PatientName from './PatientName/index'
import React from 'react'
import ToggleToolbarAction from './ToggleToolbarAction/index'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Images/ActiveTab/Images/Content/Content/Content/ImageViewer/Content"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 id="imageviewer"
 width="calc(100vw - 30px)"
 height="calc(100vh - 30px)"
 paddingTop={dtSpaceS}
 paddingBottom={dtSpaceS}
 paddingLeft={dtSpaceS}
 paddingRight={dtSpaceS}
>
{childProps => (
<React.Fragment>
<PatientImages
{...childProps}
  viewPath={`${viewPath}/PatientImages`}
/>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<PatientName
  viewPath={`${viewPath}/PatientName`}
/>
<PatientAge
  viewPath={`${viewPath}/PatientAge`}
/>
<ImageSeriesDate
  viewPath={`${viewPath}/ImageSeriesDate`}
/>
</div>
<div
  data-testid="Content.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<Info
  viewPath={`${viewPath}/Info`}
 text="💡 Hold space key to move the image"
 marginRight={32}
/>
<ToggleToolbarAction
  viewPath={`${viewPath}/ToggleToolbarAction`}
/>
<FullScreenButton
  viewPath={`${viewPath}/FullScreenButton`}
 containerId="imageviewer"
/>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 type="secondary"
 size="normal"
 text="Close"
 marginLeft={8}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../No'))}
/>
</div>
</div>
</React.Fragment>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}